import { Suspense, useEffect } from 'react';
import { normalizeVendor, PANELS } from './vendors.js';
import { rtkLog } from '../realtimekit/rtkDebug.js';

function Loading() {
  return (
    <div className="flex h-full min-h-[160px] w-full items-center justify-center bg-black text-sm text-gray-400">
      Loading host panel…
    </div>
  );
}

/**
 * MeetingPanel — renders the session's meeting panel, chosen from
 * `hosting.vendor`. All vendor knowledge lives in ./vendors.js.
 * Every panel takes the same props: { sessionId, meetingNumber, password, vendor, className }.
 */
export default function MeetingPanel({ vendor, ...props }) {
  const key = normalizeVendor(vendor);
  const Panel = PANELS[key];
  // Zoom keeps the RAW hosting.vendor for its hostvendor URL (legacy
  // behavior, e.g. "zoommsdk"); the new vendors always send their own key.
  const panelVendor = key === 'zoom' ? vendor : key;

  // One line so the console shows which panel the session actually picked —
  // a wrong `hosting.vendor` here means the wrong SDK entirely.
  useEffect(() => {
    rtkLog('MeetingPanel resolved', { rawVendor: vendor ?? null, resolvedKey: key, panelVendor });
  }, [vendor, key, panelVendor]);

  return (
    <Suspense fallback={<Loading />}>
      <Panel key={key} vendor={panelVendor} {...props} />
    </Suspense>
  );
}
